// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesCardOwnerName-moduleEntityProfileTabUpdatesCardOwnerName__MFE38";
var _2 = "EntityProfileTabUpdatesCardOwnerName-modulelink__qsvg_";
var _3 = "EntityProfileTabUpdatesCardOwnerName-moduleroleSuffix__UI3Dj";
var _4 = "EntityProfileTabUpdatesCardOwnerName-modulestaticName__pyKHu";
export { _1 as "EntityProfileTabUpdatesCardOwnerName", _2 as "link", _3 as "roleSuffix", _4 as "staticName" }
